import { produce } from 'immer';
import { StateCreator } from 'zustand';

import type { AddOn } from '../model/add-ons';
import { IWorkspaceStore } from './workspace.store';

/**
 * This is just the state of the AddOns slice.
 */
export interface AddOnsState {
  enabledAddOns: AddOn[];
}

/**
 * AddOns-related actions.
 * If you want to add more, define them here.
 */
export interface AddOnsActions {
  isAddOnEnabled: (addOn: AddOn) => boolean;
  setAddOns: (addOns: AddOnsState['enabledAddOns']) => void;
}

export type AddOnsSlice = {
  addOns: AddOnsState & AddOnsActions;
};

/**
 * Creates the AddOns slice. This function can be merged into
 * a larger store (e.g. a workspace store).
 */
export const createAddOnsSlice: StateCreator<IWorkspaceStore, [], [], AddOnsSlice> = (
  set,
  get
) => ({
  addOns: {
    enabledAddOns: [],

    isAddOnEnabled: (addOn: AddOn) => {
      const { addOns } = get();

      return addOns.enabledAddOns.includes(addOn);
    },

    setAddOns: (addOns: AddOnsState['enabledAddOns']) =>
      set(
        produce((draft: AddOnsSlice) => {
          draft.addOns.enabledAddOns = addOns;
        })
      ),
  },
});
